var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroWinHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 534,
    height: 104,
    viewBox: "0 0 534 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9546,
    width: 505.466,
    height: 93.0305,
    fill: "url(#paint0_linear_1956_74261)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6146 103.884H499.76C518.325 103.884 533.375 85.4717 533.375 62.7588V0H516.567V58.1893C516.567 77.1167 504.026 92.4604 488.555 92.4604H44.8195C29.3488 92.4604 16.8073 77.1167 16.8073 58.1893V0.0480945H0V62.7588C0 85.4717 15.0498 103.884 33.6146 103.884Z",
    fill: "#0A21A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M516.319 62.7555V33.2944V0.0484619L496.06 0.0485737V63.9334C494.915 69.0452 490.18 73.6578 481.46 79.6255C472.07 86.0527 371.715 89.1704 328.708 92.6069L341.452 93.0306C384.27 92.9513 475.23 92.8894 487.589 92.8894C503.436 92.8894 515.979 79.1372 516.319 62.7555Z",
    fill: "#EBE0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1956_74261",
    x1: 97.322,
    y1: -4.03949,
    x2: 139.682,
    y2: 142.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroWinHeader);
export default __webpack_public_path__ + "static/media/MetroWinHeader.7106ac60ccc0a347d318.svg";
export { ForwardRef as ReactComponent };